<template>
  <Modal class="my-modal withdrawal-modal" v-model="visible" title="信息确认" :transfer="false" :mask-closable="false" :closable="false" width="600">
    <Form ref="myForm" :model="formData" :label-width="80" class="page-form less">
      <FormItem prop="requestAmountRmb" label="积分">
        {{formData.requestAmountHkd}}
      </FormItem>
      <FormItem prop="bank" label="开户银行" :rules="$units.formRule.required('请选择开户银行')">
        <Select v-model="formData.bank" transfer>
          <Option v-for="item in bankList" :value="item.value" :key="item.value">{{ item.txt }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="accountOpenBranch" label="开户支行" :rules="$units.formRule.required('请输入开户支行')">
        <Input v-model="formData.accountOpenBranch" placeholder="请输入" maxlength="30" />
      </FormItem>
      <FormItem prop="userName" label="户主姓名" :rules="$units.formRule.required('请输入户主姓名')">
        <Input v-model="formData.userName" placeholder="请输入" />
      </FormItem>
      <FormItem prop="cardNo" label="银行账号" :rules="$units.formRule.required('请输入银行账号')">
        <Input v-model="formData.cardNo" placeholder="请输入" />
      </FormItem>
      <FormItem prop="type" label="账号类型" :rules="$units.formRule.required('请选择账号类型')">
        <Select v-model="formData.type" transfer>
          <Option value="1">对公</Option>
          <Option value="2">对私</Option>
        </Select>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="ok" :loading="loading">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { codeTools } from '@/api/mixins';
export default {
  mixins: [codeTools],
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      isEditIdCard: false,
      formData: {},
      bankList: [],
      loading: false
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {
    async open(data) {
      this.formData = data;
      this.getBankList();
      this.getBankInfo();
      this.queryRequestAmount();
      this.visible = true;
    },
    queryRequestAmount() {
      this.$http({
        url: '/buz/settlementTotal/queryRequestAmount',
        type: 'POST',
        data: {
          isAll: this.formData.isAll,
          totalIds: this.formData.totalIds,
          commissionPeriodStart: this.formData.commissionPeriodStart,
          commissionPeriodEnd: this.formData.commissionPeriodEnd
        }
      }).then(res => {
        this.$set(this.formData, 'requestAmountHkd', res.data.requestAmountHkd);
        this.$set(this.formData, 'requestAmountRmb', res.data.requestAmountRmb);
      });
    },
    // 获取银行列表
    getBankInfo() {
      this.$http({
        url: '/buz/settlementTotal/queryMerchantBank',
        type: 'post',
        data: {}
      }).then(res => {
        this.$set(this.formData, 'bank', res.data.bank);
        this.$set(this.formData, 'accountOpenBranch', res.data.accountOpenBranch);
        this.$set(this.formData, 'userName', res.data.userName);
        this.$set(this.formData, 'cardNo', res.data.cardNo);
        this.$set(this.formData, 'type', res.data.type);
      });
    },
    // 获取银行列表
    getBankList() {
      this.$http({
        url: '/system/dic/read/dicList',
        type: 'post',
        data: {
          code: 'BANK_TYPE'
        }
      }).then(res => {
        this.bankList = res.data;
      });
    },
    ok() {
      this.$refs.myForm.validate().then(async isok => {
        if (!isok) {
          return;
        }
        this.loading = true;
        this.$http({
          url: '/buz/settlementTotal/batchSure',
          type: 'post',
          data: this.formData
        })
          .then(res => {
            this.$notice.msg('提交成功');
            this.$emit('reload');
            this.visible = false;
          })
          .finally(res => {
            this.loading = false;
          });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.withdrawal-modal /deep/ {
  .code-btn {
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    width: 80px;
    text-align: center;
    margin: auto;
    height: 30px;
    &.blue {
      color: #236dff;
      cursor: pointer;
    }
  }
}
</style>






